<template>
  <div class="battery-add">
    <div class="row">
      <div class="label">{{ $t('lang.Commodity Type') }}</div>
      <div class="row-right">
        <el-select class="fixed-width-200" v-model="commodityType">
          <el-option v-for="(value,key) in typeList" :key="key" :label="value" :value="key"></el-option>
        </el-select>
      </div>
    </div>
    <div class="row">
      <div class="label">{{ $t('lang.Commodity Name') }}</div>
      <div class="row-right">
        <el-input class="fixed-width-200" type="text" v-model="title" :placeholder="$t('lang.Commodity Name')"></el-input>
      </div>
    </div>
    <div class="row" v-if="isInArray(commodityType)">
      <div class="label">{{ $t('lang.Battery spec') }}：</div>
      <div class="row-right">
        <el-radio-group v-model="standard">
          <!--<el-radio :label="48">48V</el-radio>-->
          <el-radio :label="60">60V</el-radio>
          <el-radio :label="72">72V</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div
      class="row"
      v-if="commodityType == '4'||
       commodityType == '15' ||
       commodityType == '10' ||
       commodityType == '12' ||
       commodityType == '13' ||
       commodityType == '14'"
    >
      <div class="label">{{ $t('lang.Effective Time') }}</div>
      <div class="row-right" style="display: inline-flex;align-items: center">
        <!--<el-radio v-model="durationType" :label="1" v-if="commodityType != '13' && commodityType != '14'">7{{$t('lang.days')}}</el-radio>-->
        <!--<el-radio v-model="durationType" :label="2" v-if="commodityType != '13' && commodityType != '14'">30{{$t('lang.days')}}</el-radio>-->
        <!--<el-radio v-model="durationType" :label="3">
          {{ $t('lang.Custom') }}&nbsp;

        </el-radio>-->
        <el-input
          class="fixed-width-200"
          type="number"
          v-model="days"
          :min="0" :max="9999"
          :disabled="durationType != '3'"
        ></el-input>&nbsp;{{$t('lang.days')}}
      </div>
    </div>
    <div class="row" v-if="commodityType == '15'">
      <div class="label">{{ $t('lang.Available Times') }}</div>
      <div class="row-right">
        <el-input class="fixed-width-200" type="number" v-model="times" :min="0" :max="9999" :placeholder="$t('lang.Available Times')"></el-input>
      </div>
    </div>
    <div class="row">
      <div class="label">{{ $t('lang.Price') }}</div>
      <div class="row-right">
        <el-input class="fixed-width-200" type="text" v-model="price" placeholder="Price"></el-input>
      </div>
    </div>
    <div class="row" v-if="commodityType == '13' || commodityType == '14'">
      <div class="label">{{ $t('lang.Compulsory Purchase') }}：</div>
      <div class="row-right">
        <el-select v-model="attribute2" placeholder="">
          <el-option
            v-for="item in compulsory_purchase"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="row" v-if="commodityType != '13' && commodityType != '14'">
      <div class="label">{{ $t('lang.Deposit') }}</div>
      <div class="row-right">
        <el-input class="fixed-width-200" type="text" v-model="deposit" :placeholder="$t('lang.Deposit')"></el-input>
      </div>
    </div>
    <!--<div class="row">
      <div class="label">{{ $t('lang.Currency') }}</div>
      <div class="row-right">
        <el-select v-model="currencyParam" placeholder="" class="fixed-width-200">
          <el-option
            v-for="item in currency_type"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>-->
    <div class="row" v-if="isRealthing(commodityType)">
      <div class="label">{{ $t('lang.Value') }}</div>
      <div class="row-right">
        <el-input class="fixed-width-200" type="text" v-model="worth" :placeholder="$t('lang.Value')"></el-input>
      </div>
    </div>
    <div class="row">
      <div class="label">{{$t('lang.Commodity Description')}}</div>
      <div class="row-right">
        <el-input
          class="fixed-width-450"
          type="textarea"
          v-model="description"
          :rows="3"
          :placeholder="$t('lang.Commodity Description')"
        ></el-input>
      </div>
    </div>

    <div class="row" v-if="commodityType != '13' && commodityType != '14'">
      <div class="label">{{ $t('lang.Stocks') }}</div>
      <div class="row-right">
        <el-input class="fixed-width-200" type="text" :placeholder="$t('lang.Unlimited')" disabled="disabled"></el-input>
      </div>
    </div>
    <div class="row">
      <div class="label">{{ $t('lang.Organization') }}</div>
      <div class="row-right">
        <query-unit-tree @change="handleChange"/>
       <!-- <el-cascader
          :options="unitList"
          :props="{ checkStrictly: true, value:'unitNo',label:'name',children:'subUnit' }"
          v-model="unitNo"
          clearable
        ></el-cascader>-->
      </div>
    </div>
    <div class="row">
      <div class="label">{{ $t('lang.Commodity State') }}</div>
      <div class="row-right">
        <el-radio-group v-model="status">
          <el-radio label="1">{{ $t('lang.On Sale') }}</el-radio>
          <el-radio label="2">{{ $t('lang.Off Sale') }}</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="row">
      <el-button  @click="cancel">{{ $t('lang.Cancel') }}</el-button>
      <el-button type="primary"  @click="confirm">{{ $t('lang.Confirm') }}</el-button>
    </div>
  </div>
</template>
<script>
import {currency_type, compulsory_purchase} from '@/utils/constant'
import queryUnitTree from '@/components/common/queryUnitTree';

export default {
  name: "commodityMgmtAddView",
  components: {
    queryUnitTree
  },
  data() {
    return {
      attribute2: '',
      compulsory_purchase,
      currencyParam: '2',
      currency_type,
      title: "",
      status: "1",
      standard: 60,
      commodityType: "",
      typeList: {
        2: this.$t('lang.Swapping Service'),
        4: this.$t('lang.Timer Card'),
        6: this.$t('lang.Battery'),
        15: this.$t('lang.Measured Card')
      },
      times: '1',
      price: "0",
      deposit: "0",
      worth: "0",
      description: "",
      unitList: [],
      unitNo: [],
      durationType: 3,
      days: "1"
    };
  },
  computed: {
    duration() {
      if (this.durationType == 1) {
        return 604800000;
      } else if (this.durationType == 2) {
        return 2592000000;
      } else if (this.durationType == 3) {
        return this.days * 24 * 60 * 60 * 1000;
      }
    }
  },
  mounted() {
    this.getUnitMember();
  },
  methods: {
    // select组件
    handleChange(val) {
      this.unitNo = val;
    },
    validateDays() {
      return !/(^[1-9]\d*$)/.test(this.days);
    },
    // 确认
    confirm() {
      this.addOrEditCommodity();
    },
    cancel() {
      this.$emit("cancel");
    },
    // 确认
    addOrEditCommodity() {
      let self = this;
      let reg = /^\d+(\.\d{1,2})?$/;
      if (this.price) {
        if (!this.price.match(reg)) {
          self.$message({
            type: "warning",
            message: this.$t('lang.Please enter the correct amount'),
            center: true
          });
          return;
        }
      }
      if (this.deposit) {
        if (!this.deposit.match(reg)) {
          self.$message({
            type: "warning",
            message: this.$t('lang.Please enter the correct amount'),
            center: true
          });
          return;
        }
      }
      if (this.worth) {
        if (!this.worth.match(reg)) {
          self.$message({
            type: "warning",
            message: this.$t('lang.Please enter the correct amount'),
            center: true
          });
          return;
        }
      }
      if ((this.commodityType == '4' ||this.commodityType == '15' || this.commodityType == '13' || this.commodityType == '14') && this.durationType == "3") {
        if (!/(^[1-9]\d*$)/.test(this.days)) {
          this.$message({
            type: "warning",
            message: this.$t('lang.Please enter the correct number of days'),
            center: true
          });
          return;
        }
      }
      if(this.commodityType == '15') {
        if(Number(this.times) < 0 || Number(this.times) > 60000 || parseInt(this.times) !== parseFloat(this.times)) {
          this.$message({
            type: "warning",
            message: this.$t('lang.Please enter the correct number of times'),
            center: true
          });
          return;
        }
      }
      if ((this.commodityType == '13' || this.commodityType == '14') && this.durationType != "3") {
        this.$message({
          type: "warning",
          message: this.$t('lang.Please enter the correct number of times'),
          center: true
        });
        return;
      }
      if (!this.currencyParam) {
        this.$message.warning(this.$t('lang.Please select a currency'));
        return;
      }
      let params = {
        title: this.title,
        status: this.status,
        commodityType: this.commodityType,
        price: this.price,
        deposit: this.deposit,
        worth: this.worth,
        unitNo: this.unitNo[this.unitNo.length - 1],
        description: this.description,
        currencyParam: this.currencyParam,
        attribute2: this.attribute2,
      };

      if (this.commodityType == 4 ||this.commodityType == 15 || this.commodityType == 10 || this.commodityType == 12) {
        params.attribute0 = this.duration;
      }
      if (this.commodityType == 4 || this.commodityType == 15) {
        params.attribute1 = this.standard;
      }
      if (this.commodityType == 6 || this.commodityType == 13 || this.commodityType == 14) {
        params.attribute0 = this.standard;
      }
      if (this.commodityType == 13 || this.commodityType == 14) {
        params.attribute1 = this.duration;
      }
      //换电卡(限次数)的次数
      if(this.commodityType == 15) {
        params.attribute2 =this.times
      }
      this.$http
        .post(
          "/managementPlatform/admin/addAndEditCommodity",
          this.$qs.stringify(params)
        )
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            if (res.message) {//错误信息提示框，问就是后端让加的
              self.$alert(res.message, self.$t('lang.Tips'))
            } else {
              self.$message({
                type: "error",
                message: self.$t('lang.failure'),
                center: true
              });
            }
            return;
          }
          if (res.message) {//有message值弹按钮框
            self.$alert(res.message, self.$t('lang.Tips')).then(() => {
              self.$emit("editSuccess");
            })
          } else {//没值弹message
            self.$message.success(self.$t('lang.Success'));
            self.$emit("addSuccess");
          }
        })
        .catch(function (e) {
          console.log(e, 'e');
        });
    },
    getUnitMember() {
      let self = this;
      let params = {
        authorityType: 231
      }
      this.$http
        .post("/managementPlatform/unit/queryManagedUnit", this.$qs.stringify(params))
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            console.log(11111);
            self.$message({
              type: "error",
              message: res.message,
              center: true
            });
            return;
          }
          self.unitList = res.mdata.unitTree;

        })
        .catch(function (e) {
          console.log(e);

        });
    },
    isInArray(type) {
      if (["4","15", "6", "13", '14'].indexOf(type) != -1) {
        return true;
      }
      return false;
    },
    isRealthing(type) {
      if (["6", "7", "9"].indexOf(type) != -1) {
        return true;
      }
      return false;
    }
  }
};
</script>
<style lang="scss" scoped>
.row {
  margin: 20px 0 0 20px;
  font-size: 14px;

  .fixed-width {
    width: 240px;
  }

  .row-right {
    display: inline-block;
    line-height: 30px;

    .top {
      vertical-align: top;
      color: #999999;
    }
  }

  .label {
    display: inline-block;
    vertical-align: top;
    text-align: left;
    min-width: 100px;
    margin-right: 14px;
    line-height: 25px;
  }

  .blue-btn {
    margin-right: 10px;
  }

  .table-custom {
    width: 1080px;
  }

  .fixed-width-100 {
    width: 100px;
    vertical-align: top;
  }

  .fixed-width-200 {
    width: 200px;
    vertical-align: top;
  }

  .days {
    width: 100px;
    text-align: center;
  }

  .fixed-width-350 {
    width: 350px;
    vertical-align: top;
  }

  .fixed-width-450 {
    width: 450px;
    vertical-align: top;
  }

  .text {
    line-height: 32px;
  }

  .btn {
    cursor: pointer;
  }

  .icon {
    color: #67aa42;
    font-size: 20px;
  }
}

.amap-demo {
  height: 300px;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/commodityMgmt/commodityMgmtAddView.vue